import React, { useEffect } from "react";
import { inject, observer } from 'mobx-react';
import { pgChangeColumns, TableOptions, selectSize, localization } from '../Constants';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner'
import MaterialTable from "material-table";
import Select from "react-select";
import ReportsMenu from '../ReportsMenu';
import '../Reporting.css';

const PgChangesTable = inject('RootStore')(observer(({ RootStore }) => {
  useEffect((() => {
    RootStore.reportingStore.setRenderSpinner(true)
    RootStore.reportingStore.getPgChangesData(1000)
  }), [RootStore.reportingStore]);

  const handleChange = selectedOption => {
    RootStore.reportingStore.setRenderSpinner(true)
    RootStore.reportingStore.getPgChangesData(selectedOption.value)
  };

  return (
    <div className="row">
      {RootStore.reportingStore.renderSpinner && <LoadingSpinner text='Loading reports'/>}
      <ReportsMenu/>
      <div className="col-sm-9" id="report-table">
        <div>
          {<MaterialTable
            title="Permission Group Changes Report"
            data={RootStore.reportingStore.getPgChanges}
            columns={pgChangeColumns}
            options={TableOptions}
            localization={localization}
          />}
          <div className="select-item">
            <Select onChange={handleChange} menuPlacement="top" options={selectSize}/>
          </div>
        </div>
      </div>
    </div>
  )
}));

export default PgChangesTable;